import React from "react";
import styled from "styled-components";

interface ButtonGridProps {
  buttons: { label: string; icon?: React.ReactNode; onClick: () => void }[];
}

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
  max-width: 400px;
  margin: 100px 0 0 25px;
`;

const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  background-color: #f7f7f7;
  color: #005ca9;
  padding: 20px;
  width: 200px;
  height: 80px;
  border-radius: 30px;
  cursor: pointer;
  transition: background 0.3s;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  h1 {
    font-size: 20px;
    font-weight: 600;
    text-align: start;
  }

  &:hover {
    background-color: #e0e0e0;
  }
`;

const ButtonGrid: React.FC<ButtonGridProps> = ({ buttons }) => {
  return (
    <GridContainer style={{ gridTemplateColumns: `repeat(${Math.min(buttons.length, 3)}, 1fr)` }}>
      {buttons.map((btn, index) => (
        <Button key={index} onClick={btn.onClick}>
          {btn.icon && <span>{btn.icon}</span>}
          <h1>{btn.label}</h1>
        </Button>
      ))}
    </GridContainer>
  );
};

export default ButtonGrid;
